import * as ActionTypes from './actions';

const releaseNotes = (state = [], action) => {
	switch (action.type) {
		case ActionTypes.RELEASE_NOTES_SUCCESS:
			return action.payload;
		default:
			return state;
	}
};

export default releaseNotes;